<template>
  <div class="cursor" data-cy="agenda-item-container">
    <div
      class="border-top p-1 font-italic bg-light small"
      v-if="agenda.multiplo"
      data-cy="agenda-item-aviso-multiplo"
    >
      <font-awesome-icon
        icon="arrow-circle-down"
        class="text-info"
        data-cy="agenda-item-icon-multiplo"
      />
      Atendimento por ordem de chegada dentro horário agendado.
    </div>
    <div
      class="border-top p-1 font-italic bg-light small"
      v-if="agenda.observacaoMarcacaoOnline"
      data-cy="agenda-item-observacao"
    >
      <font-awesome-icon
        icon="exclamation-triangle"
        class="text-info"
        data-cy="agenda-item-icon-observacao"
      />
      <strong data-cy="agenda-item-texto-observacao">{{
        agenda.observacaoMarcacaoOnline
      }}</strong>
    </div>
    <div
      class="px-2 pt-2 d-flex flex-wrap align-items-center border-top flex-grow-1"
      data-cy="agenda-item-horarios-container"
    >
      <div
        class="celula px-4 py-2 border"
        @click="submit(horario)"
        :class="applySelect(horario.id)"
        v-for="horario in agenda.horarios"
        :key="horario.id"
        :data-cy="`agenda-item-horario-${horario.id}`"
      >
        <strong
          class="calendar-button-text-color active"
          :data-cy="`agenda-item-horario-texto-${horario.id}`"
          >{{ horario.label }}</strong
        >
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "schedule-geral-item",
  props: ["agenda", "reschedule"],
  data() {
    return {
      horario: null
    };
  },
  methods: {
    applySelect(id) {
      if (this.horario) {
        return this.horario.id === id ? "calendar-button-selected-color" : "";
      } else {
        return this.selectedHorario === id &&
          this.selectedAgenda === this.agenda.id
          ? "calendar-selected-color"
          : "";
      }
    },
    submit(horario) {
      this.horario = horario;
      this.$nextTick(function() {
        let selected = {
          id: horario.id,
          agendaId: this.agenda.id,
          nome: `${moment(horario.hora).format("DD/MM")} - ${horario.label}`,
          date: horario.hora,
          medics: [],
          stepId: 4
        };

        this.$store.dispatch("load_selected", selected);
        this.$emit("submit", horario);
      });
    }
  },
  computed: {
    selectedHorario() {
      return this.$store.getters.get_selected[3].id;
    },
    selectedAgenda() {
      return this.$store.getters.get_selected[3].agendaId;
    }
  }
};
</script>

<style>
.cursor {
  cursor: pointer;
}
</style>
